export const DAY_KEYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export const DAY_LABELS = {
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
};

const WEEKDAY_DEFAULT = { closed: false, open: "09:00", close: "17:00" };
const WEEKEND_DEFAULT = { closed: true, open: null, close: null };

export const buildDefaultStructuredHours = () => ({
  monday: { ...WEEKDAY_DEFAULT },
  tuesday: { ...WEEKDAY_DEFAULT },
  wednesday: { ...WEEKDAY_DEFAULT },
  thursday: { ...WEEKDAY_DEFAULT },
  friday: { ...WEEKDAY_DEFAULT },
  saturday: { ...WEEKEND_DEFAULT },
  sunday: { ...WEEKEND_DEFAULT },
});

export const normalizeStructuredHours = (structured) => {
  const base = buildDefaultStructuredHours();
  if (!structured) return base;
  DAY_KEYS.forEach((day) => {
    if (structured[day]) base[day] = { closed: !!structured[day].closed, open: structured[day].open || null, close: structured[day].close || null };
  });
  return base;
};
